export const IconSettings = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0503 10.6064L2.97924 17.6775C2.19819 18.4585 2.19819 19.7248 2.97924 20.5059C3.76028 21.2869 5.02661 21.2869 5.80766 20.5059L12.8787 13.4348"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0502 10.6066C9.20639 8.45363 9.37135 5.62865 11.1109 3.88914C12.8504 2.14962 16.0606 1.76782 17.8284 2.82848L14.7877 5.86915L14.5051 8.98019L17.6161 8.69758L20.6568 5.6569C21.7175 7.42467 21.3357 10.6349 19.5961 12.3744C17.8566 14.1139 15.0316 14.2789 12.8786 13.435"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
